import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconTraectoryOrangeSizeS from './IconTraectoryOrange_size_s';

const props: CreateIconArguments = {
  l: IconTraectoryOrangeSizeS,
  m: IconTraectoryOrangeSizeS,
  s: IconTraectoryOrangeSizeS,
  xs: IconTraectoryOrangeSizeS,
  name: 'IconTraectoryOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
